var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedoNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9127 -0.00050354L24.0557 5.14351L18.9127 10.2865V6.0005H6.91266C5.54866 6.0005 4.24051 6.54235 3.27601 7.50685C2.31151 8.47135 1.76966 9.7795 1.76966 11.1435C1.76966 12.5075 2.31151 13.8157 3.27601 14.7802C4.24051 15.7447 5.54866 16.2865 6.91266 16.2865H12.0557V18.0005H6.91266C6.01219 18.0005 5.12053 17.8232 4.2886 17.4786C3.45667 17.134 2.70076 16.6289 2.06403 15.9921C1.4273 15.3554 0.922219 14.5995 0.577622 13.7676C0.233026 12.9356 0.0556641 12.044 0.0556641 11.1435C0.0556641 10.243 0.233026 9.35138 0.577622 8.51945C0.922219 7.68753 1.4273 6.93161 2.06403 6.29488C2.70076 5.65814 3.45667 5.15305 4.2886 4.80846C5.12053 4.46386 6.01219 4.28651 6.91266 4.28651H18.9127V-0.00050354Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoNewIcon);
export default __webpack_public_path__ + "static/media/Redo-New-Icon.a337f746cdbfeadc077f7233de621648.svg";
export { ForwardRef as ReactComponent };